<template>
  <div>
    <ak-type-input hideLabel v-model="data.sales" :field="options" />
  </div>
</template>
<script>
import Bus from '@/assets/js/eventBus'
import store from '@/store'
export default {
  syncProps: ['value'],
  props: {
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    field: Object, // 当前field对象
  },
  data () {
    return {
      filters: {},
      // gdUser: [],
      data: {
        sales: []
      },
      options: {
        name: 'sales',
        note: '销售人员',
        type: 'Array',
        items: { type: 'Pointer', targetClass: '_User' },
        listWhere: (where) => {
          where.username = { $exists: true }
          if (store.state.user && store.state.user.allClient === 'No') {
            if (store.state.user.correlatedBy && store.state.user.correlatedBy.length) {
              where.$or = [
                {
                  objectId: store.state.user.objectId
                },
                {
                  objectId: { $in: store.state.user.correlatedBy }
                }
              ]
            } else {
              where.objectId = store.state.user.objectId
            }
          }
        }
      }
    }
  },

  mounted () {
    Bus.$on('reset', this.reset)
  },
  methods: {
    filterQuery () {
      if (this.data.sales.length) {
        this._value = this.data.sales
      } else {
        this._value = 'null'
      }
      // if (this._value) {
      return this._value
      // }
    },
    setValue () {
      this._value = null // 不会报错
    },
    async search (filters) {
    },
    reset (payLoad) {
      this.data.sales = payLoad
    }
  },
}
</script>

<style>

</style>
